/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import TYPES from '../action-types';

import { reducer as getSavedSearches } from './getAll';
import { reducer as addSavedSearch } from './add';
import { reducer as removeSavedSearch } from './remove';
import { reducer as favoriteSavedSearch } from './favorite';
import { reducer as search } from './search';
import { reducer as setActive } from './setActive';
import { reducer as update } from './update';
import { reducer as rename } from './rename';
import { reducer as createGroup } from './createGroup';
import { reducer as move } from './move';
import { reducer as renameGroup } from './renameGroup';
import { reducer as deleteGroup } from './deleteGroup';

const initialState = {
  isLoaded: false,
  isAdding: false,
  tree: {},
  all: [],
  searchQuery: '',
  activeSavedSearch: null,
  error: null,
};

const savedSearchesReducer = createReducer(
  initialState,
  (builder) => {
    getSavedSearches(builder);
    addSavedSearch(builder);
    removeSavedSearch(builder);
    favoriteSavedSearch(builder);
    search(builder);
    setActive(builder);
    update(builder);
    rename(builder);
    createGroup(builder);
    move(builder);
    deleteGroup(builder);
    renameGroup(builder);

    /** Reset activeSavedSearch when certain actions are dispatched */
    builder.addMatcher(
      (action) => (action.type === TYPES.COLLECTIONS.SET_ACTIVE
        || action.type === TYPES.LIGHTBOARDS.SET_ACTIVE
        || action.type === 'archive/setActiveCollection'
        || action.type === 'keywords/setActive'
        || action.type === 'collections/setActiveCollection'
        || action.type === 'lightboards/setActiveLightboard'
        || action.type === 'inboxes/setActiveInbox'
      ),
      (state) => {
        state.activeSavedSearch = null;
      },
    );
  },
);

export default savedSearchesReducer;
